var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4064 0.745226L10.8278 2.32356L15.6761 7.17104L17.2547 5.59271C17.7328 5.11816 18 4.47136 18 3.79643C18 3.12151 17.7328 2.47471 17.2547 2.00016L15.9995 0.745226C15.5249 0.267156 14.878 0 14.2029 0C13.5279 0 12.881 0.267156 12.4064 0.745226ZM9.6359 3.51522L2.06989 11.0764C1.6937 11.4526 1.41946 11.9236 1.27531 12.4368L0.0307198 16.9293C-0.0501437 17.221 0.0307197 17.5374 0.2487 17.7518C0.46668 17.9663 0.779586 18.0506 1.0714 17.9698L5.5646 16.7219C6.0779 16.5778 6.54551 16.3071 6.92521 15.9274L14.4842 8.3627L9.6359 3.51522Z",
    fill: "#003032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDetails);
export default __webpack_public_path__ + "static/media/edit-details.ad93a73a016cff1d9b62a95ac41f88a1.svg";
export { ForwardRef as ReactComponent };